import { createBrowserHistory } from 'history'

import * as Bridge from '@/api/BridgeApi'
import { OKSign } from '@/domains/CommonDomain'
import { SchedulePaymentHistoryParams } from '@/domains/SchedulePaymentDomain'
import { TransactionType } from '@/domains/TransferDomain'
import { queryStringToObject } from '@/utils/navigationUtils'
import { toInteger } from '@/utils/numberUtils'

export enum HISTORY_ACTION_TYPE {
  POP = 'POP',
  PUSH = 'PUSH',
  REPLACE = 'REPLACE',
}

export const browserHistory = createBrowserHistory()

export function push(targetUrl: string) {
  browserHistory.push(targetUrl)
}

export function redirect(targetUrl: string) {
  browserHistory.replace(targetUrl)
}

export function reload() {
  window.location.reload()
}

interface IEntryLocation {
  entry: string
}

export function checkEntry() {
  const { entry } = queryStringToObject<IEntryLocation>(browserHistory.location.search, {
    entry: '',
  })

  return !!entry
}

interface IResetLocation {
  reset: string
}

export function checkReset() {
  const { reset } = queryStringToObject<IResetLocation>(browserHistory.location.search, {
    reset: '',
  })

  return !!reset
}

interface IFromRegisterLocation {
  from: string
}

export function checkFromRegister() {
  const { from } = queryStringToObject<IFromRegisterLocation>(browserHistory.location.search, {
    from: '',
  })

  return from === 'register'
}

export function goBack() {
  checkEntry() ? Bridge.closeWebView() : browserHistory.goBack()
}

export function getSchedulePaymentContext(): SchedulePaymentHistoryParams {
  const {
    crAcctNo: bnfcAcctNo,
    crBnkCd: bnfcBankCd,
    crBnkNm: bnfcBankNm,
    trscType,
    crAcctNm1,
    crAcctNm2,
    crAcctTitle,
    trxAmt,
  } = queryStringToObject(browserHistory.location.search, {
    crBnkCd: '',
    crAcctNo: '',
    trscType: '',
    trxAmt(value: string) {
      return toInteger(value)
    },
    crAcctNm1(value: string) {
      return decodeURIComponent(value)
    },
    crAcctNm2(value: string) {
      return decodeURIComponent(value)
    },
    crBnkNm(value: string) {
      return decodeURIComponent(value)
    },
    crAcctTitle(value: string) {
      return decodeURIComponent(value)
    },
  })
  const isMyAccount = trscType === TransactionType.MY_ACCOUNT

  return {
    bnfcAcctNo,
    bnfcBankCd,
    bnfcNm: `${crAcctNm1}${crAcctNm2}`,
    bnfcBankNm: isMyAccount ? crAcctTitle : bnfcBankNm,
    trscType,
    myAcctYn: isMyAccount ? OKSign.YES : OKSign.NO,
    trxAmt,
  }
}

export default browserHistory
